import React from 'react'
import './styles/WidgetTG.css'

import { useGlobalContext } from '../context'
import TGPlayerHost from './TGPlayerHost'
import TGPlayerGuest from './TGPlayerGuest'

export default function WidgetTG() {
  const { hostTeamMates, guestTeamMates } = useGlobalContext()

  console.log(hostTeamMates)
  return (
    <div className='tg-container'>
      <div className='tg-hosts'>
        {hostTeamMates.map((player, index) => {
          return <TGPlayerHost key={index} player={{ ...player, index }} />
        })}
      </div>
      <div className='tg-guests'>
        {guestTeamMates.map((player, index) => {
          return <TGPlayerGuest key={index} player={{ ...player, index }} />
        })}
      </div>
    </div>
  )
}
